import { render, staticRenderFns } from "./UserPersonalCardForm.vue?vue&type=template&id=2fcb8288&"
import script from "./UserPersonalCardForm.vue?vue&type=script&lang=js&"
export * from "./UserPersonalCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports